import { useQuery } from '@tanstack/react-query';

const getConfig = () => fetch('/config.json').then((res) => res.json());

export const useConfig = () => {
  return useQuery(['config'], getConfig, { staleTime: Infinity });
};
